import { Component } from '@angular/core';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { ExpectedBillModel } from 'app/models/expected-bill.model';
import { ExpectedBillService } from 'app/services/expected-bill.service';

@Component({
  standalone: false,
  selector: 'app-expected-bill',
  templateUrl: './expected-bill.component.html',
  styleUrls: ['./expected-bill.component.scss']
})
export class ExpectedBillComponent extends NexusComponent {
  public expected_bill_result: NexusFormResultModel = new NexusFormResultModel();
  public expected_bill_model: ExpectedBillModel = new ExpectedBillModel();

  public expected_bill_form = new UntypedFormGroup({
    utilities_start_date: this.CreateRequiredFormControl()
  });

  constructor(private route: ActivatedRoute, private router: Router,private expected_bill_service: ExpectedBillService) { 
    super();
  }

  ngOnInit(): void {
    this.route.data.subscribe(({expected_bill_model}) => {
      this.expected_bill_model = expected_bill_model;
      this.expected_bill_form.patchValue({
        utilities_start_date:this.expected_bill_model.utilities_start_date, 
      });
  });
    this.expected_bill_form.valueChanges.subscribe((form: any) => {
      this.PopulateModelFromForm(form, this.expected_bill_model);
    });
  }

  submit(event) {
    this.expected_bill_result.Reset();

    this.SetFormTouched(this.expected_bill_form);
    if (this.expected_bill_form.invalid) {
      this.expected_bill_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.expected_bill_service.SaveExpectedBill(this.expected_bill_model).subscribe(
      data => {
        this.expected_bill_model = data;
        this.StopSpinner();
        this.expected_bill_result.Success('Expected bill Saved!');
        this.router.navigate(['/billing','expected-bills']);
      },
      err => {
        this.expected_bill_result.Error(err);
        this.StopSpinner();
      });
  }
}